<template>
<div>
  <v-pagination
    v-if="pageCount > 1"
    v-model="pageNumber"
    color="accent"
    :length="pageCount"
  />
</div>
</template>

<script>
export default {
  props: {
    dataLength: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return { 
      pageNumber: 1
    }
  },
  computed: {
        pageCount() {
            let l = this.dataLength,
            s = this.size;
            return Math.ceil(l / s);
        },
    },
  watch: {
    pageNumber(val) {
      this.$emit('input', val)
    }
  },
}
</script>